import { React, useState } from "react";
import {
  Button,
  Chip,
  Divider,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import AppButton from "../../../../../base/AppButton.component";
import { DialogStyle } from "./Dialog.styles";
import { EMAIL_BILL_INPUT } from "../../../../../../graphql/mutation/mutation";
import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { CheckCircle, Group } from "@mui/icons-material";
import { InputValidation } from "../../../../../../utils/InputValidationRegex";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
let file_name;
const EmailBillingDialog = (props) => {
  const theme = useTheme();
  const { data } = props;
  const [emails, setEmails] = useState([data?.email]);
  const [user, setUser] = useState({
    email: "",
    subject: "",
    body: "",
    attachment: "",
    fileName: "",
  });
  const addEmail = () => {
    if (
      user.email.trim() !== "" &&
      !InputValidation.emailValidation(user.email)
    ) {
      setEmails((prevEmails) => [...prevEmails, user.email]);
      console.log("dddddddd", emails);
      setUser({ ...user, email: "" });
    }
  };
  const handleDelete = (emailToDelete) => {
    setEmails(emails.filter((email) => email !== emailToDelete));
  };
  useEffect(() => {
    if (data) {
      setUser({
        email: "",
        subject: "This Month's Invoice",
        // subject: `Bill report for month ${new Date().toLocaleString("en-US", {
        // month: "long",
        // })} ${new Date().getFullYear()}`,
      });
    }
  }, [data]);

  // const StyledTextarea = styled(TextareaAutosize)(
  //   ({ theme }) => `
  //   width: 100%;
  //   height:50%;
  //   font-family: Open Sans;
  //   font-size: 0.875rem;
  //   font-weight: 400;
  //   line-height: 1.5;
  //   padding: 12px;
  //   border-radius: 6px 6px 0 6px;

  //   &:focus {
  //     border-color: #00AB55;
  //   }

  //   // firefox
  //   &:focus-visible {
  //     outline: 0;
  //   }
  // `
  // );
  const [sendEmailBill, { loading: updateLoading, data: emailBilling }] =
    useMutation(EMAIL_BILL_INPUT);

  useEffect(() => {
    if (emailBilling) {
      console.log("emailbilling", emailBilling);
    }
  }, [emailBilling]);

  const handleFileSelection = async (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const reader = new FileReader();
      file_name = selectedFile.name;
      reader.readAsDataURL(selectedFile);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        setUser({ ...user, attachment: base64String });
      };
    }
  };
  const emailBillHandler = () => {
    sendEmailBill({
      variables: {
        emailBillInput: {
          email: emails,
          subject: user.subject,
          body: user.body,
          attachment: user.attachment,
          fileName: file_name,
        },
      },
    });
  };

  return (
    <>
      <style>{`
    td{
     border-bottom:none !important;
     cursor:default;
    }
  `}</style>
      <Divider />
      <Box>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>To</TableCell>
              <TableCell>
                {/* <Typography sx={{ color: !user.email && "#E15656" }}>
                  {user.email || "Please update dealership email"}
                </Typography> */}
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <FormControl
                    variant="outlined"
                    sx={{ width: "100%", marginTop: "10px" }}
                  >
                    <InputLabel
                      color={
                        InputValidation.emailValidation(user.email)
                          ? "error"
                          : "primary"
                      }
                    >
                      Email
                    </InputLabel>
                    <OutlinedInput
                      required
                      label="Email"
                      type="email"
                      value={user.email}
                      onChange={(e) =>
                        setUser({ ...user, email: e.target.value })
                      }
                    />
                    <FormHelperText sx={{ color: theme.palette.error.main }}>
                      {InputValidation.emailValidation(user.email)
                        ? "Please enter a valid email"
                        : " "}
                    </FormHelperText>
                  </FormControl>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={addEmail}
                    sx={{ mb: "5px" }}
                  >
                    <AddCircleOutlineIcon color="primary" />
                  </IconButton>
                </Box>
                <Box>
                  {console.log("eeee", user)}
                  {emails.map((email, index) => (
                    <Chip
                      icon={<Group />}
                      key={index}
                      label={email}
                      onClick={() => {
                        console.log("You clicked the Chip.");
                      }}
                      onDelete={() => handleDelete(email)}
                      style={{ margin: "1px" }}
                      variant="outlined"
                      color="primary"
                    />
                  ))}
                  {console.log("abc", emails)}
                </Box>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Subject</TableCell>
              <TableCell>
                <FormControl variant="outlined" sx={DialogStyle.width}>
                  <OutlinedInput
                    required
                    value={user.subject}
                    onChange={(event) =>
                      setUser({ ...user, subject: event.target.value })
                    }
                  />
                </FormControl>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ verticalAlign: "top" }}>Message</TableCell>
              <TableCell>
                {/* <StyledTextarea
                  style={{ resize: "vertical" }}
                  minRows={5}
                  placeholder="Enter your message"
                  value={user.body}
                  onChange={(event) =>
                    setUser({ ...user, body: event.target.value })
                  }
                  autoFocus
                  dir="auto"
                /> */}

                <FormControl variant="outlined" sx={DialogStyle.width}>
                  <OutlinedInput
                    required
                    value={user.body}
                    onChange={(event) =>
                      setUser({ ...user, body: event.target.value })
                    }
                    multiline
                    rows={4}
                    rowsMax={10}
                  />
                </FormControl>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell>Attachment</TableCell>
              <TableCell>
                <>
                  <FormControl variant="outlined" sx={{ width: "100%" }}>
                    <InputLabel>
                      {user?.attachment ? file_name : "Choose file"}
                    </InputLabel>
                    <OutlinedInput
                      type="text"
                      sx={DialogStyle.width}
                      disabled={true}
                      endAdornment={
                        <InputAdornment position="end">
                          <input
                            accept=".xls, .xlsx, application/vnd.ms-excel,  application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            style={{ display: "none" }}
                            id="raised-button-file"
                            type="file"
                            onChange={handleFileSelection}
                          />
                          <label htmlFor="raised-button-file">
                            <Button variant="raised" component="span">
                              Upload
                            </Button>
                          </label>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Divider />
        <Box sx={DialogStyle.emailButton}>
          {emailBilling?.sendEmailBill?.status ? (
            <Box sx={{ display: "flex", my: "12px" }}>
              <CheckCircle color={"primary"} />
              <span
                style={{ color: theme.palette.primary.main, marginLeft: "4px" }}
              >
                SUCCESS
              </span>
            </Box>
          ) : (
            <AppButton
              buttonText="Send"
              clickHandler={emailBillHandler}
              sx={{ width: "200px" }}
              disabled={
                emails.length <= 0 ||
                user.body === undefined ||
                user?.body === ""
              }
            />
          )}
        </Box>
      </Box>
    </>
  );
};
export default EmailBillingDialog;
